import Modal from "../../common/components/Modal";
import useMediaQuery, { useIsMinTabletSize } from "../../common/hooks/useMediaQuery";
import { Button } from "~/common/components/Button/Button";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/utils/screenSizes";
import { doLogout } from "~/Header/api/doLogout";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { redirectToSrp } from "~/utils/redirectionUtil";
import { Stacker } from "~/common/components/Stacker/Stacker";
import {
  GridGappedContainerDirection,
  GridGappedContainerSize,
} from "~/common/components/GridGappedContainer/GridGappedContainer";
import { Alert } from "~/common/m3/Alert/Alert";
import { AlertTitle } from "@mui/material";

const SignOutFromPlusPopUp = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const isMinTablet = useIsMinTabletSize();
  const [showPopup, setShowPopup] = useState(true);

  const onClose = () => {
    setShowPopup(false);
    redirectToSrp();
  };

  const onLogout = () => {
    setShowPopup(false);
    doLogout(true, true);
  };

  const footer = (
    <Stacker direction={"row"} gap={8}>
      <Button color={"primary"} variant={"text"} data-test-id={"login-cancel-button"} onClick={onClose}>
        {t("cancel")}
      </Button>
      <Button fullWidth={!isMinTablet} onClick={onLogout}>
        {t("popup.sign.out")}
      </Button>
    </Stacker>
  );

  return (
    showPopup && (
      <Modal
        onClose={onClose}
        footerChildren={footer}
        title={t("popup.signout.message")}
      >
        <Stacker gap={GridGappedContainerSize.S_24} direction={GridGappedContainerDirection.COLUMN}>
          <div style={{ paddingTop: "8px" }}>
            <Alert severity={"info"}>
              <AlertTitle>{t("popup.signout.info.header")}</AlertTitle>
              {t("popup.signout.info.message")}
            </Alert>
          </div>
        </Stacker>
      </Modal>
    )
  );
};
export default SignOutFromPlusPopUp;
